import { Injectable } from "@angular/core";
import { BackendService } from "../backend/backend.service";

@Injectable({
  providedIn: "root"
})
export class UploadCSRCService {
  constructor(private backendService: BackendService) {}

  private path = "/csrc";

  saveImportCRSC(uploadcsrcdata) {
    return this.backendService.post(this.path + "/import", uploadcsrcdata);
  }

  searchCsrc(currPage: number, pageSize: number, filter: any) {
    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };

    return this.backendService.post(this.path + "/search", data);
  }

  deleteAll(csrc) {
    return this.backendService.post(this.path + "/delete", csrc);
  }

  getCsrcById(csrcId) {
    return this.backendService.get(this.path + "/" + csrcId);
  }

  saveCsrc(data) {
    return this.backendService.post(this.path + "/", data);
  }

  deleteCsrc(id) {
    return this.backendService.post(this.path + "/" + id + "/delete", {});
  }
}
